import { render, staticRenderFns } from "./UnitFormGridPanel.vue?vue&type=template&id=06b02e2c&"
import script from "./UnitFormGridPanel.vue?vue&type=script&lang=js&"
export * from "./UnitFormGridPanel.vue?vue&type=script&lang=js&"
import style0 from "./UnitFormGridPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports